import type { AlertProps } from '~/plugins/01.alert.client'

type AlertController = {
   show: (props: AlertProps) => Promise<boolean>
   hide: () => void
}

export const useAlert = (): AlertController => {
   const { $alert } = useNuxtApp()
   return $alert as AlertController
}
